module.exports = __webpack_public_path__ + "img/brittleLava.7b18b320.jpg";